// src/products.js

const products = [
  // T-Shirts
  {
    id: 1,
    name: "Atomic Pi",
    category: "Math",
    type: "tshirt",
    price: 25.0,
    images: [
      "/images/atomic-pi-01.png",
      "/images/atomic-pi-02.png",
      "/images/atomic-pi-03.png",
      "/images/atomic-pi-04.png",
      "/images/atomic-pi-05.png"
    ],
    description: {
      intro:
        "Best in its category, this 100% combed cotton shirt is for those who don’t compromise on quality. It’s soft and will feel luxurious against your skin. The regular fit and crew neck create a timeless look. Pre-shrunk for lasting shape and crafted with thick yarns for durability, this tee is wear and tear-resistant. Customize with your design and add your branding to the inside label.",
      bullets: [
        "100% combed cotton",
        "Marles color is 85% cotton and 15% viscose",
        "Fabric weight: 5.3 oz./yd.² (150.25 g/m²)",
        "Yarn diameter: 28 singles",
        "Pre-shrunk",
        "Regular fit",
        "Crew neck",
        "Side-seamed construction",
        "Double-needle topstitch on the sleeves and hem",
        "Ribbed collar",
        "Shoulder-to-shoulder taping",
        "Tear-away label",
        "Blank product sourced from Bangladesh"
      ]
    }
  },
  {
    id: 2,
    name: "Experiments",
    category: "Science",
    type: "tshirt",
    price: 25.0,
    images: [
      "/images/experiments-01.png",
      "/images/experiments-02.png",
      "/images/experiments-03.png",
      "/images/experiments-04.png",
      "/images/experiments-05.png"
    ],
    description: {
      intro: "Best in its category...",
      bullets: [] // same bullets as above
    }
  },
  {
    id: 3,
    name: "Fractal Infinity",
    category: "Math",
    type: "tshirt",
    price: 25.0,
    images: [
      "/images/fractal-infinity-01.png",
      "/images/fractal-infinity-02.png",
      "/images/fractal-infinity-03.png",
      "/images/fractal-infinity-04.png",
      "/images/fractal-infinity-05.png"
    ],
    description: {
      intro: "Best in its category...",
      bullets: []
    }
  },
  {
    id: 4,
    name: "Galaxy Hacker",
    category: "Technology",
    type: "tshirt",
    price: 25.0,
    images: [
      "/images/galaxy-hacker-01.png",
      "/images/galaxy-hacker-02.png",
      "/images/galaxy-hacker-03.png",
      "/images/galaxy-hacker-04.png",
      "/images/galaxy-hacker-05.png"
    ],
    description: {
      intro: "Best in its category...",
      bullets: []
    }
  },
  {
    id: 5,
    name: "Golden Ratio",
    category: "Math",
    type: "tshirt",
    price: 25.0,
    images: [
      "/images/golden-ratio-01.png",
      "/images/golden-ratio-02.png",
      "/images/golden-ratio-03.png",
      "/images/golden-ratio-04.png",
      "/images/golden-ratio-05.png"
    ],
    description: {
      intro: "Best in its category...",
      bullets: []
    }
  },
  {
    id: 6,
    name: "Quantum Chess",
    category: "Chess",
    type: "tshirt",
    price: 25.0,
    images: [
      "/images/quantum-chess-01.png",
      "/images/quantum-chess-02.png",
      "/images/quantum-chess-03.png",
      "/images/quantum-chess-04.png",
      "/images/quantum-chess-05.png"
    ],
    description: {
      intro: "Best in its category...",
      bullets: []
    }
  },

  // Hoodies
  {
    id: 7,
    name: "Atomic Pi Hoodie",
    category: "Math",
    type: "hoodie",
    price: 40.0,
    images: [
      "/images/hoodie-atomic-pi-01.png",
      "/images/hoodie-atomic-pi-02.png",
      "/images/hoodie-atomic-pi-03.png",
      "/images/hoodie-atomic-pi-04.png",
      "/images/hoodie-atomic-pi-05.png",
      "/images/hoodie-atomic-pi-06.png"
    ],
    description: {
      intro:
        "Classic unisex hoodie with a front pouch pocket and matching flat drawstrings. The 100% cotton exterior makes this hoodie soft to the touch. What's more, if you go with custom prints, you can personalize the hoodie to your heart’s content and maximize your branding thanks to the custom inside label.",
      bullets: [
        "65% ring-spun cotton, 35% polyester",
        "Charcoal Heather is 60% ring-spun cotton, 40% polyester",
        "Carbon Grey is 55% ring-spun cotton, 45% polyester",
        "100% cotton face",
        "Fabric weight: 8.5 oz./yd.² (288.2 g/m²)",
        "Front pouch pocket",
        "Self-fabric patch on the back",
        "Matching flat drawstrings",
        "3-panel hood",
        "Tear-away tag",
        "Blank product sourced from Pakistan"
      ]
    }
  },
  {
    id: 8,
    name: "Experiments Hoodie",
    category: "Science",
    type: "hoodie",
    price: 40.0,
    images: [
      "/images/hoodie-experiments-01.png",
      "/images/hoodie-experiments-02.png",
      "/images/hoodie-experiments-03.png",
      "/images/hoodie-experiments-04.png",
      "/images/hoodie-experiments-05.png",
      "/images/hoodie-experiments-06.png"
    ],
    description: {
      intro: "Classic unisex hoodie...",
      bullets: []
    }
  },
  {
    id: 9,
    name: "Fractal Infinity Hoodie",
    category: "Math",
    type: "hoodie",
    price: 40.0,
    images: [
      "/images/hoodie-fractal-infinity-01.png",
      "/images/hoodie-fractal-infinity-02.png",
      "/images/hoodie-fractal-infinity-03.png",
      "/images/hoodie-fractal-infinity-04.png",
      "/images/hoodie-fractal-infinity-05.png",
      "/images/hoodie-fractal-infinity-06.png"
    ],
    description: {
      intro: "Classic unisex hoodie...",
      bullets: []
    }
  },
  {
    id: 10,
    name: "Galaxy Hacker Hoodie",
    category: "Technology",
    type: "hoodie",
    price: 40.0,
    images: [
      "/images/hoodie-galaxy-hacker-01.png",
      "/images/hoodie-galaxy-hacker-02.png",
      "/images/hoodie-galaxy-hacker-03.png",
      "/images/hoodie-galaxy-hacker-04.png",
      "/images/hoodie-galaxy-hacker-05.png",
      "/images/hoodie-galaxy-hacker-06.png"
    ],
    description: {
      intro: "Classic unisex hoodie...",
      bullets: []
    }
  },
  {
    id: 11,
    name: "Golden Ratio Hoodie",
    category: "Math",
    type: "hoodie",
    price: 40.0,
    images: [
      "/images/hoodie-golden-ratio-01.png",
      "/images/hoodie-golden-ratio-02.png",
      "/images/hoodie-golden-ratio-03.png",
      "/images/hoodie-golden-ratio-04.png",
      "/images/hoodie-golden-ratio-05.png",
      "/images/hoodie-golden-ratio-06.png"
    ],
    description: {
      intro: "Classic unisex hoodie...",
      bullets: []
    }
  },
  {
    id: 12,
    name: "Quantum Chess Hoodie",
    category: "Chess",
    type: "hoodie",
    price: 40.0,
    images: [
      "/images/hoodie-quantum-chess-01.png",
      "/images/hoodie-quantum-chess-02.png",
      "/images/hoodie-quantum-chess-03.png",
      "/images/hoodie-quantum-chess-04.png",
      "/images/hoodie-quantum-chess-05.png",
      "/images/hoodie-quantum-chess-06.png"
    ],
    description: {
      intro: "Classic unisex hoodie...",
      bullets: []
    }
  }
];

export default products;
